// @flow
import React from 'react'
import Error from 'components/Error'
import { connect } from 'react-redux'
import { httpGet } from 'lib/http'
import { setLoad, setUnload } from 'lib/notification/actions'
import { Template } from './Template'
import { withRouter } from 'lib/hooks/withRouter'

type Props = {
  dispatch: Function,
  location: Object,
  navigate: Function,
}

class EditSubaccount extends React.Component {
  props: Props
  constructor(props) {
    super(props)
    this.state = {
      error: false,
      subaccount: null,
      accountSummary: null,
      notes: [],
      attachments: [],
      lineItems: [],
      loading: true,
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = () => {
    const {
      dispatch,
      location: {
        params: { number, subnumber },
      },
    } = this.props

    dispatch(setLoad())

    const subaccountUrl = `/admin/accounts/${number}/subaccounts/${subnumber}`
    const accountSummaryUrl = `/admin/accounts/${number}?summary=true`

    Promise.all([httpGet(subaccountUrl), httpGet(accountSummaryUrl)])
      .then(([subaccountResponse, accountSummaryResponse]) => {
        const subaccount = subaccountResponse.subaccount || subaccountResponse.data?.subaccount
        const accountSummary = accountSummaryResponse.data || accountSummaryResponse

        if (!subaccount) {
          this.setState({ error: true, loading: false })
          return
        }

        const notes = subaccount.notes || []
        const attachments = subaccount.attachments || []
        const lineItems = subaccount.line_items || []

        this.setState({
          error: false,
          subaccount,
          accountSummary,
          notes,
          attachments,
          lineItems,
          loading: false,
        })
      })
      .catch(() => {
        this.setState({ error: true, loading: false })
      })
      .then(() => {
        dispatch(setUnload())
      })
  }

  handleSuccess = () => {
    this.fetchData()
  }

  render() {
    const { error, subaccount, accountSummary, notes, attachments } = this.state
    const { dispatch } = this.props

    if (error) {
      return <Error title="404: Account Not Found" message="The account you are looking for does not exist" icon="account" />
    }

    const {
      location: {
        params: { number, subnumber },
      },
    } = this.props

    return (
      <Template
        subaccount={subaccount}
        accountSummary={accountSummary}
        accountNumber={number}
        subnumber={subnumber}
        notes={notes}
        attachments={attachments}
        dispatch={dispatch}
        onSuccess={this.handleSuccess}
      />
    )
  }
}

export default withRouter(connect()(EditSubaccount))
